import React from 'react';
import { Box } from '@mui/material';
import BottomNav from './BottomNav';

/**
 * Container component for pages with bottom navigation
 * Adds proper spacing to ensure content doesn't get hidden behind bottom nav
 */
const PageContainer = ({ 
  children, 
  showBottomNav = true,
  bottomNavHeight = 72 // Slightly more than BottomNav height (68px) to ensure no content is cut off
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      paddingBottom: showBottomNav ? `${bottomNavHeight}px` : 0
    }}>
      {children}
      
      {showBottomNav && <BottomNav />}
    </Box>
  );
};

export default PageContainer;
